export default __webpack_public_path__ + "static/media/cirun-one-line.2a862d7d.gif";